import React   from 'react'
import navIcon4 from '../assets/img/Logos.png';
import projeImg4 from "../assets/img/game.svg";
import projeImg5 from "../assets/img/img2.png";
import projeImg6 from "../assets/img/ab.png";
import play from "../assets/img/google-play.svg";
import app from "../assets/img/app-store-ios.svg";
import Huwai from "../assets/img/Huwai.svg";
import TrackVisibility from 'react-on-screen';
import  NavbarPrices  from "./NavbarPrices";
import { Container, Row, Col, Tab, Nav} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import 'react-bootstrap-icons'


export const Games = () => {
  return (
    <>
    <NavbarPrices/> 
    
    <div className='games'>
    <div class="row ">
      
    
    <div class="col-12 col-md-6 col-lg-4">
      
      <h2>Adventure Games</h2>
      <br></br>
      <hr></hr>
      <Row className="aligh-items-center">
     <Col xs={12} md={6} xl={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img className="ab" src={projeImg4} alt="Header Img"/>
                  
                </div>}
            </TrackVisibility>
            
          </Col>
       </Row>
       
       
    </div>
    <div class="col-12 col-md-6 col-lg-4">
     <h2>Puzzle Games</h2> 
     <br></br>
      <hr></hr>
      <Row className="aligh-items-center">
     <Col xs={12} md={6} xl={6}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img className="ab" src={projeImg5} alt="Header Img"/>
                  
                </div>}
            </TrackVisibility>
            
          </Col>
       </Row>   
       
    </div>
    <div class="col-12 col-md-6 col-lg-4">
     <h2>Racing Games</h2> 
     <br></br>
      <hr></hr>
      <Row className="aligh-items-center">
     <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img className="ab" src={projeImg6} alt="Header Img"/>
                  
                </div>}
            </TrackVisibility>
            
          </Col>
       </Row>   
       
    </div>
  </div>
  </div>  
  </>
  )
}

